import "./WistiaVideo.scss";
const WistiaVideo = ({ vId, w, h, W, H }) => {
  return (
    <div className="video_cover">
      <iframe
        src={`https://fast.wistia.net/embed/iframe/${vId}`}
        allow="autoplay;"
        allowTransparency="true"
        title="Wistia video"
        style={{
          aspectRatio: `${w / h}`,
          minHeight: w && h ? `100vh` : "",
          minWidth: w && h ? `100vw` : "",
          objectFit: w && h ? "cover" : "",
        }}
      ></iframe>
    </div>
  );
};

export default WistiaVideo;
